import { useEffect, useState } from 'react'
import { onThemeChange, setTheme, EThemeMode } from '@/utils/bridge'

const useThemeChange = () => {
    const [themeMode, setThemeMode] = useState(EThemeMode.default)
    useEffect(() => {
        // @ts-ignore
        return onThemeChange(setThemeMode)
    }, [])

    useEffect(() => { 
        // @ts-ignore
        setTheme(themeMode)
    }, [themeMode])
}

export default useThemeChange